<template>
    <div class="floor-3">
        <!-- 楼层标题 -->
        <div class="floor_title">
            <div class="floor_title_content">
                <span class="floor_title_border"></span>
                <span class="floor_title_content_index">{{ floorConfig.title || "3F" }}</span>
                <img src="../../../assets/images/floor_title.png" alt />
                <span class="floor_title_content_text">{{ floorConfig.subTitle || "NiuShop" }}</span>
            </div>

            <!-- 右侧分类链接区 -->
            <div class="other-title" v-if="floorConfig.titleLink">
                <router-link :to="floorConfig.titleLink.url">{{ floorConfig.titleLink.content }} <i class="iconfont iconarrow-right"></i></router-link>
            </div>
        </div>
        <!-- 楼层内容区 -->
        <div class="floor-content">
            <cargo-item :cargo="item" v-for="(item, index) in skuList" :key="index" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import CargoNormal from "@/components/cargo/CargoNormal"
    import { floorGoods, goodsSkuList } from "@/api/goods/goods"
    import CargoItem from "./cargo_item_2"

    export default {
        name: "style1",
        components: {
            CargoNormal,
            CargoItem
        },
        props: {
            config: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                floorConfig: {
                    validated: false,
                    rightCargos: []
                },
                skuList: []
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
            this.getSkuList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            handleCargoClick(skuId) {
                if (skuId) {
                    this.$router.pushToTab(`/sku-${skuId}`)
                }
            },
            getSkuList() {
                const sku_ids = this.floorConfig.rightCargos
                    .map(item => {
                        return item.sku_id
                    })
                    .toString()

                goodsSkuList({ sku_ids })
                    .then(res => {
                        this.skuList = res.data
                    })
                    .catch(err => {})
            }
        },
        watch: {
            config: {
                handler: function(curr) {
                    if (curr && curr.rightCargos) {
                        this.floorConfig = { ...curr, validated: true }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floor-3 {
        margin-top: 25px;
        .floor_title_content {
            display: flex;
            flex-direction: column;
            align-items: center;
            .floor_title_content_index {
                font-size: 26px;
                font-weight: 600;
            }
            .floor_title_content_text {
                color: rgba($color: #383838, $alpha: 0.2);
                font-size: 24px;
                text-transform: uppercase;
                letter-spacing: 5px;
                font-weight: 600;
            }
        }
        .other-title {
            text-align: right;
            margin-right: 15px;
            a {
                color: #838383;

                i {
                    font-size: 14px;
                }

                &:hover {
                    color: $base-color;
                }
            }
        }
        .floor-content {
            display: flex;
            flex-wrap: wrap;
        }
    }
</style>
